import { apiFetch } from './client';
import type { Periodo } from './tienda.api';

/** Seguimiento de ventas y Eficiencia. Prefijos: /api/seguimiento y /api/eficiencia */

export type EstadoDeSeguimiento = 'PENDIENTE' | 'COMPRO' | 'NO_COMPRO';
export type MotivoNoCompro = 'precio' | 'no_habia' | 'compro_en_otro_lado' | 'no_contesto' | 'otro';

export const MOTIVOS: Array<{ id: MotivoNoCompro; etiqueta: string }> = [
  { id: 'precio', etiqueta: 'Le pareció caro' },
  { id: 'no_habia', etiqueta: 'No había lo que buscaba' },
  { id: 'compro_en_otro_lado', etiqueta: 'Compró en otro lado' },
  { id: 'no_contesto', etiqueta: 'No volvió a contestar' },
  { id: 'otro', etiqueta: 'Otro motivo' },
];

export const ORIGEN: Record<string, string> = {
  IA: 'El asistente lo pasó',
  ASESORA: 'Lo marcó la vendedora',
  BORRADOR: 'Venta en borrador',
};

export interface Seguimiento {
  id: string;
  conversationId: string;
  contactId: string;
  asignadaAId: string | null;
  ubicacionId: string | null;
  anuncioSourceId: string | null;
  anuncioTitulo: string | null;
  estado: EstadoDeSeguimiento;
  origen: 'IA' | 'ASESORA' | 'BORRADOR';
  resumen: string | null;
  motivo: MotivoNoCompro | null;
  nota: string | null;
  volverEl: string | null;
  saleId: string | null;
  montoVenta: number | null;
  creadoAt: string;
  cerradoAt: string | null;
  cliente?: string;
  telefono?: string | null;
  vendedora?: string | null;
  sucursal?: string | null;
}

export function listar(query: { estado?: EstadoDeSeguimiento; periodo?: Periodo | 'todo' }): Promise<Seguimiento[]> {
  return apiFetch<Seguimiento[]>('/api/seguimiento', { query });
}

export function delChat(conversationId: string): Promise<Seguimiento | null> {
  return apiFetch<Seguimiento | null>(`/api/seguimiento/chat/${conversationId}`);
}

export function quedoEnComprar(
  conversationId: string,
  body: { nota?: string | null; volverEl?: string | null },
): Promise<Seguimiento> {
  return apiFetch<Seguimiento>(`/api/seguimiento/chat/${conversationId}`, { method: 'POST', body });
}

export type Accion =
  | { tipo: 'no_compro'; motivo: MotivoNoCompro; nota?: string | null }
  | { tipo: 'volver'; volverEl: string; nota?: string | null }
  | { tipo: 'reabrir' };

export function marcar(id: string, accion: Accion): Promise<Seguimiento> {
  return apiFetch<Seguimiento>(`/api/seguimiento/${id}/accion`, { method: 'POST', body: accion });
}

export interface FilaDeEficiencia {
  clave: string;
  nombre: string;
  chats: number;
  pasaron: number;
  compraron: number;
  noCompraron: number;
  pendientes: number;
  vencidos: number;
  ventas: number;
  vendido: number;
  tasaDeCierre: number | null;
  costo: number | null;
  costoPorChat: number | null;
  costoPorVenta: number | null;
  retorno: number | null;
}

export interface Eficiencia {
  periodo: Periodo;
  total: FilaDeEficiencia;
  porAnuncio: FilaDeEficiencia[];
  porVendedora: FilaDeEficiencia[];
  porSucursal: FilaDeEficiencia[];
}

export function eficiencia(periodo: Periodo): Promise<Eficiencia> {
  return apiFetch<Eficiencia>('/api/eficiencia', { query: { periodo } });
}

export function ponerCosto(body: { sourceId: string; titulo?: string | null; costo: number }) {
  return apiFetch('/api/eficiencia/costo-anuncio', { method: 'PUT', body });
}
